import React, { useState } from 'react';
import axios from '../config/axios';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import { useTheme } from '../context/ThemeContext';

const steps = [
  'Generar Identificación',     // Paso 0: Generar y guardar imagen inicial
  'Enviar Identificación',      // Paso 1: Enviar y guardar imagen recibida
  'Recibir Identificación',     // Paso 2: Subir imagen del cliente
  'Enviar Integridad',         // Paso 3: Enviar email de integridad
  'Confirmar Integridad',      // Paso 4: Cliente confirma integridad
  'Firmar Contrato'            // Paso 5: Cliente firma el contrato final
];

function IdentificationDialog({ open, contractId, onClose, contract }) {
  const { themeColors } = useTheme();
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Generar Identificación
  const generateIdentification = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `/api/contracts/${contractId}/identification/generate`,
        {
          nombre: contract.nombre,
          apellido: contract.apellido,
          documento_tipo: contract.documento_tipo,
          documento_id: contract.documento_id,
          duracion: contract.duracion
        },
        { responseType: 'blob' }
      );
      const url = URL.createObjectURL(response.data);
      setImageUrl(url);
    } catch (err) {
      setError('Error al generar la identificación');
    } finally {
      setLoading(false);
    }
  };

  // Aceptar Generación y Descargar
  const handleGenerateAccept = async () => {
    try {
      setLoading(true);
      
      // Primero descargamos la imagen
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = `identificacion_${contract.nombre}_${contract.apellido}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Luego marcamos como aceptada
      await axios.post(`/api/contracts/${contractId}/identification/accept`);
      onClose(true);
    } catch (err) {
      console.error('Error:', err);
      setError('Error al procesar la identificación');
    } finally {
      setLoading(false);
    }
  };

  // Función para descargar la imagen
  const handleDownload = async () => {
    try {
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = `identificacion_${contract.nombre}_${contract.apellido}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error('Error al descargar:', err);
      setError('Error al descargar la imagen');
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose()} maxWidth="md" fullWidth>
      <DialogTitle>Generar Identificación</DialogTitle>

      <DialogContent>
        {error && (
          <Typography color="error" gutterBottom align="center">
            {error}
          </Typography>
        )}

        {loading ? (
          <Box textAlign="center" my={4}>
            <CircularProgress />
          </Box>
        ) : (
          <Box textAlign="center" my={2}>
            {!imageUrl ? (
              <Button 
                variant="contained"
                onClick={generateIdentification}
                sx={{ 
                  backgroundColor: themeColors.primary,
                  '&:hover': { backgroundColor: themeColors.secondary }
                }}
              >
                Generar Identificación
              </Button>
            ) : (
              <>
                <img src={imageUrl} alt="Identificación" style={{ maxWidth: '100%' }} />
                <Box mt={2}>
                  <Button onClick={() => onClose()} sx={{ mr: 2 }}>
                    Cancelar
                  </Button>
                  <Button 
                    variant="contained"
                    onClick={handleGenerateAccept}
                    sx={{ 
                      backgroundColor: themeColors.primary,
                      '&:hover': { backgroundColor: themeColors.secondary }
                    }}
                  >
                    Aceptar y Descargar
                  </Button>
                </Box>
              </>
            )}
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default IdentificationDialog; 